import styled from 'styled-components';
import {GameBox} from '../../../single-game/regular-template/boxes/game/game.box';
import { CssRule } from '../../../../themes/architecture/css-helpers/css-rule';


export const GamePlaceHolderDefaultBox = styled(GameBox)`
     ${CssRule.For.mobile.embededHybrid.build()} & , ${CssRule.For.mobile.miniOrbit.build()} & {
        display: none;
    }
`;